import PropTypes from 'prop-types';
import React, { useState, useEffect } from "react";

import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

// Reactstrap
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";
import megamenuImg from "../../assets/images/megamenu-img.png";
import io from 'socket.io-client';
import PopupModal from "../../components/Common/popupModal";
import EmergencyDialog from "../../components/EmergencyDialog";

import logo from "../../assets/images/logo.svg";
import logoLightSvg from "../../assets/images/logo-light.svg";

//i18n
import { withTranslation } from "react-i18next";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import { messages } from 'common/data';

const Header = props => {
  const [search, setsearch] = useState(false);
  const [megaMenu, setmegaMenu] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);
  const [socket, setSocket] = useState(null);
  const [notifs, setNotifs] = useState([]);
  const [data, setData] = useState(null);
  const [emergencyData, setEmergencyData] = useState(null);

  useEffect(() => {
    // setSocket(io('https://n.cargo.cargooapp.com'));
    console.log('connecting to socket');
    // setSocket(io('https://n.cargooapp.com'));
    const newSocket = io('http://127.0.0.1:4000');
    setSocket(newSocket);

    // Listen for emergency notifications
    newSocket.on('notify', (notificationData) => {
      // Parse the notification if it's a string, otherwise use as is
      const notification = typeof notificationData === 'string' 
        ? JSON.parse(notificationData) 
        : notificationData;
      
      console.log('Received emergency notification:', notification);
      
      if (!notification) {
        console.error('Received empty notification');
        return;
      }
      
      setEmergencyData({
        title: notification.title || 'Driver Emergency',
        message: notification.message || 'An emergency has been reported.',
        orderId: notification.orderId,
        show: notification.resever === "admin"? true : false,
      });
    });

    // Clean up on unmount
    return () => {
      newSocket.off('notify');
      newSocket.disconnect();
    };

    // return () => {
    //   socket.disconnect();
    // };
  }, []);

  useEffect(() => {
    if(socket)
    {
      console.log('socket connected');
      const st = JSON.parse(localStorage.getItem('authUser'));
      const userId = st.user.id;

      const r = socket?.emit("newUser", userId);
      console.log('Emit, new user', r)
      socket.on('notify', (data) => {
      console.log('receiving notifications');
        if(!data || data=='') return;
        const msg = JSON.parse(data);
        if(st.user.partner?.id != msg.userId && !st.user.Roles.includes(2))
          return;
        console.log('received notification', msg);
        const n = notifs;
        n.push(msg);
        setData(msg);
        setTimeout(()=>{setData(null)},6000)
        setNotifs(n);
      });
  
      return () => {
        socket.disconnect();
      };
  
    }
    else
    {

    }
  }, [socket]);
  
  
  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }

  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <PopupModal show={data && data !=''} title={data?.title} message={data?.message} orderId={data?.orderId}  />
        {emergencyData?.show && (
          <EmergencyDialog 
            title={emergencyData.title} 
            message={emergencyData.message} 
            onClose={() => setEmergencyData(null)} 
          />
        )}
        <div className="navbar-header">
          <div className="d-flex">

            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="22" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>


            <Dropdown
              className="dropdown-mega d-none d-lg-block ms-2"
              isOpen={megaMenu}
              toggle={() => {
                setmegaMenu(!megaMenu);
              }}
            >
            </Dropdown>
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search);
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <LanguageDropdown />

            <Dropdown
              className="d-none d-lg-inline-block ms-1"
              isOpen={socialDrp}
              toggle={() => {
                setsocialDrp(!socialDrp);
              }}
            >
            </Dropdown>

            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon "
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div>

            <NotificationDropdown notifs={notifs} key={notifs} />
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
